import { Injectable } from '@angular/core';

// Ionic Modules
import { AlertController } from '@ionic/angular';
import { AlertOptions } from '@ionic/core';
import { Preferences } from '@capacitor/preferences';

// Abstracts
import {
    NgPreferenceService,
    NgAnalyticsService,
    NgNotificationService } from '../abstracts';


@Injectable()
export class PreferenceService implements NgPreferenceService {

    constructor(
        private analyticsService: NgAnalyticsService,
        private alertController: AlertController,
        private notificationService: NgNotificationService) { }

    public async init(): Promise<any> {
        await Preferences.migrate();
        await this.set('intro', false);
        return this.setServices();
    }

    public keys(): Promise<string[]> {
        return Preferences.keys().then((x) => x.keys);
    }

    public get<T>(key: string): Promise<T> {
        return Preferences.get({ key })
            .then((x) => JSON.parse(x.value));
    }

    public set(key: string, value: any): Promise<void> {
        return Preferences.set({ key, value: JSON.stringify(value) })
            .then(() => this.setServices());
    }

    public async askForPermission(options: AlertOptions): Promise<void> {
        const alertOptions: AlertOptions = { backdropDismiss: false };
        const alert = await this.alertController.create({ ...options, ...alertOptions });
        return alert.present();
    }

    private async setServices(): Promise<void> {
        return new Promise(async (resolve, reject) => {
            await this.analyticsService.toggle(await this.get<boolean>('analytics'));
            this.notificationService.init(await this.get<boolean>('benachrichtigungen'));
            resolve();
        });
    }

}
